'use client';

import { c as _c } from "react/compiler-runtime";
import { ServerStyleSheet, StyleSheetManager, ThemeProvider } from 'styled-components';
import { ComponentProps, useState } from 'react';
import { useServerInsertedHTML } from 'next/navigation';
import { GlobalStyles, isDarkMode } from '@/theme';
import { darkTheme } from '@/theme/dark';
import { lightTheme } from '@/theme/light';
function StyleRegistry(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const [styledComponentsStyleSheet] = useState(_temp);
  let t1;
  if ($[0] !== styledComponentsStyleSheet) {
    t1 = () => {
      const styles = styledComponentsStyleSheet.getStyleElement();
      styledComponentsStyleSheet.instance.clearTag();
      return styles;
    };
    $[0] = styledComponentsStyleSheet;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useServerInsertedHTML(t1);
  if (typeof window !== "undefined") {
    return children;
  }
  let t2;
  if ($[2] !== children || $[3] !== styledComponentsStyleSheet.instance) {
    t2 = <StyleSheetManager sheet={styledComponentsStyleSheet.instance}>{children}</StyleSheetManager>;
    $[2] = children;
    $[3] = styledComponentsStyleSheet.instance;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp() {
  return new ServerStyleSheet();
}
export default function NextThemeProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const theme = isDarkMode() ? darkTheme : lightTheme;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <GlobalStyles />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <StyleRegistry><ThemeProvider theme={theme}>{t1}{children}</ThemeProvider></StyleRegistry>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}